import { render, staticRenderFns } from "./PrizeCategorySelect.vue?vue&type=template&id=13937cf4&"
import script from "./PrizeCategorySelect.vue?vue&type=script&lang=js&"
export * from "./PrizeCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports